module.exports = __webpack_public_path__ + "static/huawei-badge-black-dca9373584cf551ed798fba559c1fd52.png";